/*
import {
  hf,
  ht,
  cr,
  gs,
  ls,
  BtnC,
  GridC,
  MsgC,
} from 'lib';
*/
import * as GridC from "./_cccGridC";
import * as BtnC from "./_cccBtnC";
import * as MsgC from "./_cccMsgC";
import * as cr from './_cr';
import * as gs from "./_csGbl";
import * as ls from "./_csLcl"; // local state
import * as ht from './_ht';

import * as icm from './icm';

import * as Iccv20 from './icvBaseS10Rz';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  const _gUserz = gs.useUserz();
  const _udtThis = ls.udtThis();

  icm.loadAtTopAsync({
    _31r_fst: _gUserz.crt._31rz?._fst,
    frcUdt: _udtThis,
  });

  return (
    cr.c(Iccv20.N, {
      key: -10,
      cz: {
//        fcyName: '山内地区センター',
        pageName: '基本設定',
      },
      oClds: [

        cr.c(GridC.N, {
          key: -10,
          abtType: 'homeCmnz',
            lineCs: [
              {
                cellCs: [
                  {
                    oClds: [
                      cr.c(MsgC.N, {
                        key: -10,
                        cz: {
                          ls: [
                            {
                              msgCz: {
                                textz: {
                                  pfx: '各種設定の途中変更は、すでに設定済の団体のものにも適用されますのでご注意ください。',
                                }
                              }
                            }
                          ]
                        }
                      })
                    ],
                  }
                ]
              },
              {
                cellCs: [
                  {
                    oClds: [
                      icm.chkPmn('2z311') ?
                      cr.c(BtnC.N, {
                        key: -10,
                        abtType: 'homeStf2z',
                        lblCz: {
                          textz: {
                            pfx: '団体種別'
                          },
                        },
                        pslPtyz: {
                          onPress: () => {
                            cr.moveTo({
                              pageName: 'icvI15S10Rz',
                            });
                          }
                        },
                      })
                      : undefined
                    ],
                  },
                  {
                    oClds: [
                      icm.chkPmn('2z411') ?
                      cr.c(BtnC.N, {
                        key: -10,
                        abtType: 'homeStf2z',
                        lblCz: {
                          textz: {
                            pfx: 'ジャンル'
                          },
                        },
                        pslPtyz: {
                          onPress: () => {
                            cr.moveTo({
                              pageName: 'icvI16S10Rz',
                            });
                          }
                        },
                      })
                      : undefined
                    ],
                  },
                  {
                    oClds: [
                      icm.chkPmn('2z511') ?
                      cr.c(BtnC.N, {
                        key: -10,
                        abtType: 'homeStf2z',
                        lblCz: {
                          textz: {
                            pfx: '時間帯区分'
                          },
                        },
                        pslPtyz: {
                          onPress: () => {
                            cr.moveTo({
                              pageName: 'icvI11S10Rz',
                            });
                          }
                        },
                      })
                      : undefined
                    ],
                  },
                ]
              },
              {
                cellCs: [
                  {
                    oClds: [
                      icm.chkPmn('2z611') ?
                      cr.c(BtnC.N, {
                        key: -10,
                        abtType: 'homeStf2z',
                        lblCz: {
                          textz: {
                            pfx: '部屋'
                          },
                        },
                        pslPtyz: {
                          onPress: () => {
                            cr.moveTo({
                              pageName: 'icvI10S10Rz',
                            });
                          }
                        },
                      })
                      : undefined
                    ],
                  },
                  {
                    oClds: [
                      _gUserz.crt.i19rz?.i19ra2210i == 1 &&
                      icm.chkPmn('2z711') ?
                      cr.c(BtnC.N, {
                        key: -10,
                        abtType: 'homeStf2z',
                        lblCz: {
                          textz: {
                            pfx: '備品・駐車場'
                          },
                        },
                        pslPtyz: {
                          onPress: () => {
                            cr.moveTo({
                              pageName: 'icvI17S10Rz',
                            });
                          }
                        },
                      })
                      : undefined
                    ],
                  },
                  {
                    oClds: [
                      icm.chkPmn('2z811') ?
                      cr.c(BtnC.N, {
                        key: -10,
                        abtType: 'homeStf2z',
                        lblCz: {
                          textz: {
                            pfx: 'スタッフ登録'
                          },
                        },
                        pslPtyz: {
                          onPress: () => {
                            cr.moveTo({
                              pageName: 'icv_10S10Rz',
                            });
                          }
                        },
                      })
                      : undefined
                    ],
                  },
                ]
              },
              {
                cellCs: [
                  {
                    oClds: [
                      icm.chkPmn('2z911') ?
                      cr.c(BtnC.N, {
                        key: -10,
                        abtType: 'homeStf2z',
                        lblCz: {
                          textz: {
                            pfx: '権限分類'
                          },
                        },
                        pslPtyz: {
                          onPress: () => {
                            cr.moveTo({
                              pageName: 'icv_41S10Rz',
                            });
                          }
                        },
                      })
                      : undefined
                    ],
                  },
                  {
                    oClds: [
                      icm.chkPmn('2za11') ?
                      cr.c(BtnC.N, {
                        key: -10,
                        abtType: 'homeStf2z',
                        lblCz: {
                          textz: {
                            pfx: 'スタッフ権限割当'
                          },
                        },
                        pslPtyz: {
                          onPress: () => {
                            cr.moveTo({
                              pageName: 'icv_42S10Rz',
                            });
                          }
                        },
                      })
                      : undefined
                    ],
                  },
                  {
                    oClds: [
                      icm.chkPmn('2zb11') ?
                      cr.c(BtnC.N, {
                        key: -10,
                        abtType: 'homeStf2z',
                        lblCz: {
                          textz: {
                            pfx: '文書変更・その他設定'
                          },
                        },
                        pslPtyz: {
                          onPress: () => {
                            cr.moveTo({
                              pageName: 'icv_51S10Rz',
                            });
                          }
                        },
                      })
                      : undefined
                    ],
                  },
                ]
              },
              {
                cellCs: []
              },
            ]
        })

      ]
    })
  );
};
